import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import _ from 'lodash';
import sidebarStyles from './sidebar.module.scss';
import { generateServiceCityLinkData } from '../../helpers';

const Sidebar = () => {
    const data = useStaticQuery(graphql`
    query LocationsSideBarQuery {
        graphCMS {
            featuredLocationLists(last: 1) {
                id
                service {
                    id
                    slug
                }
                cities (orderBy: name_ASC) {
                    id
                    slug
                    name
                    state {
                        slug
                    }
                }
            }
        }
    }
`);

    const { sidebarContainer, sidebarHeading } = sidebarStyles;
    const { featuredLocationLists } = data.graphCMS;
    const { cities, service } = _.head(featuredLocationLists);

    return (
        <div className={sidebarContainer} data-testid="sidebar">
            <h3 className={sidebarHeading}>Lawn Care by Location</h3>
            <ul>
                {
                    _.map(cities, (city) => {
                        const { to, linkText } = generateServiceCityLinkData({ city, service });

                        return (
                            <li key={to}>
                                <Link
                                    to={to}
                                    data-testid={to}
                                >
                                    {linkText}
                                </Link>
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    );
};


export default Sidebar;
